import { render, staticRenderFns } from "./ed-board-v2.component.vue?vue&type=template&id=722f5cfa&scoped=true&"
import script from "./ed-board-v2.component.ts?vue&type=script&lang=ts&"
export * from "./ed-board-v2.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-board.component.scss?vue&type=style&index=0&id=722f5cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f5cfa",
  null
  
)

export default component.exports